<template>
  <div>
    <div ref="window"></div>
    <button style="display:none;" className="button" @click="dhxWindow.show()" class="custom-button">
      Show Window
    </button>
  </div>
</template>
<script setup>
import { deviceStore } from './../stores/deviceStore'

const store = deviceStore();
//import {} from "../assets/suite.min.js";
</script>
<script>
export default {
  name: "WindowBase",
  data () {
    return {
      dhxWindow : {},
      windowHtml : null,
      AlertGuid : null,
      alertPlayback : null,
      alertSource : null,
      windowid : null
    }
  },
  mounted() {
      //let alertObj = {"buttons":[{"id":"Answer","name":"Answer","callbackFunc":btnAlerttest},{"id":"Deny","name":"Deny","callbackFunc":btnAlerttest2}],context:{},body:"<p>Audio Call Started</p><p> Please Press Accept To Continue Or Decline To Drop</p>"};
      //this.createAlert(alertObj);
      //this.createAlertRingElement();
  },
  methods: {
      showAlert: function(alertObj) {
      console.log("Got Alert params",alertObj);

          let title,width,height,top,closable,resizable,movable,modal,alertID;
          if(alertObj.title) { title = alertObj.title } else { title = "Welcome to Simplia"};
          if(alertObj.width) { width = alertObj.width } else { width = "440"};
          if(alertObj.height) { height = alertObj.height } else { height = "auto"};
          if(alertObj.top) { top = alertObj.top } else { top = "60"};
          if(alertObj.closable) { closable = alertObj.closable } else { closable = true};
          if(alertObj.resizable) { resizable = alertObj.resizable } else { resizable = false};
          if(alertObj.movable) { movable = alertObj.movable } else { movable = true};
          if(alertObj.modal) { modal = alertObj.modal } else { modal = false};
          if(alertObj.AlertID == undefined) {alertObj.AlertID =  window.LivingScript_0070.guid.generateSync() };

          this.dhxWindow[alertObj.AlertID] = new dhx.Window({
              title: title,
              modal: true,
              footer: true,
              closable: closable,
              resizable: resizable,
              movable: movable,
              modal: modal,
              width: "440",
              height: "auto",
              top:top
          });
          this.createAlert(alertObj);
          if((alertObj.height) || (alertObj.width)) {
             this.setSize(width,height,alertObj);
          }
          this.dhxWindow[alertObj.AlertID].show();
      },
      setSize(width,height,alertObj) {
        this.dhxWindow[alertObj.AlertID].setSize(parseInt(width, 10), parseInt(height, 10));
      },
      hideAlert: function(alertObj) {
          console.log("hide alert params",alertObj);
          if(alertObj && alertObj.AlertID) {
             this.dhxWindow[alertObj.AlertID].hide();
          }
      },
      createAlert : function(params) {
          this.createAlertRingElement();

          this.dhxWindow[params.AlertID].footer.data.add({
              type: "spacer",
          });

          if(params.HeaderButtons.length > 0) {
              params.HeaderButtons.forEach((btn) => {
                  console.log("got alert header btn",btn);

                  this.dhxWindow[params.AlertID].header.data.add({
                      type: "button",
                      view: "flat",
                      size: "medium",
                      color: "primary",
                      value: btn.name,
                      id: btn.id,
                  },btn.position);

                  this.dhxWindow[params.AlertID].header.events.on("click", (id) => {
                    this.dhxWindow.hide();

                    if(document.getElementById(this.windowid)) {
                        document.getElementById(this.windowid).querySelectorAll('iframe').forEach((item) => {
                            if(item && item.contentWindow && item.contentWindow[btn.formData]) {
                              item.contentWindow[btn.formData]();
                              if(id === btn.id) {
                               btn.callbackFunc(null,btn.formData);
                              }
                            }
                             console.log("Iframe item", item);
                         });
                      } else {
                        let FormValues = [];
                        let nodeList = document.querySelectorAll("input");
                        if(nodeList.length > 0) {
                          for (let i = 0; i < nodeList.length; i++) {
                                 let id = nodeList[i].id;
                                 let value = nodeList[i].value;
                                 let FormObj ={id:value};
                                 FormValues.push(FormObj);
                          }
                        }
                        if(id === btn.id) {
                           btn.callbackFunc(null,FormValues);
                           this.dhxWindow[params.AlertID].hide();
                        }
                      }
                  });
              });
          }

          if(params.FooterButtons.length > 0) {
              params.FooterButtons.forEach((btn) => {
                  console.log("got alert btn",btn);

                  this.dhxWindow[params.AlertID].footer.data.add({
                      type: "button",
                      view: "flat",
                      size: "medium",
                      color: "primary",
                      value: btn.name,
                      id: btn.id,
                  });

                  this.dhxWindow[params.AlertID].footer.events.on("click", (id) => {
                      console.log("Footer Clicked");
                      if(document.getElementById(this.windowid)) {
                        let result = null;
                        document.getElementById(this.windowid).querySelectorAll('iframe').forEach((item) => {
                          if(item && item.contentWindow && item.contentWindow[btn.formData]) {
                            result = item.contentWindow[btn.formData]();
                            console.log("Iframe result ",result);
                          }
                           console.log("Iframe item", item);
                          });
                          if(id === btn.id) {
                            btn.callbackFunc(null,result);
                            this.stopAnnouncement({AlertID:params.AlertID});
                            console.log("=show hide alert",this.dhxWindow[params.AlertID]);
                            this.dhxWindow[params.AlertID].hide();
                          }
                      } else {
                          let FormValues = [];
                          let nodeList = document.querySelectorAll("input");
                          if(nodeList.length > 0) {
                            for (let i = 0; i < nodeList.length; i++) {
                                   let id = nodeList[i].id;
                                   let value = nodeList[i].value;
                                   let FormObj ={id:value};
                                   FormValues.push(FormObj);
                            }
                          }
                          console.log("Button ID : ", id, btn.id);
                          if(id === btn.id) {
                             //if(FormValues && FormValues.length > 0) {
                              btn.callbackFunc(null,FormValues);
                            //}
                             this.stopAnnouncement({AlertID:params.AlertID});
                             console.log("=show hide alert",this.dhxWindow[params.AlertID]);
                             this.dhxWindow[params.AlertID].hide();
                          }
                      }
                  });
              });
          }
          if(params.soundFile) {
            this.startAnnouncement({soundFile : params.soundFile,AlertID:params.AlertID});
          } else {
            this.startAnnouncement({soundFile : "https://oxygencommunications.s3.us-east-1.amazonaws.com/recordings/ringtones/ringtwo.mp3",AlertID:params.AlertID});
          }
          this.windowid = window.LivingScript_0070.guid.generateSync();
          let htmldata = '<div id="' + this.windowid + '">' + params.body + '</div>';
          this.dhxWindow[params.AlertID].attachHTML(htmldata);

          //let framenodeList = document.getElementById('mynewframe').contentWindow.document.querySelectorAll("input");
          //console.log("frame node list",framenodeList);

          /*
           document.getElementById(this.windowid).querySelectorAll('iframe').forEach((item) => {
              console.log("Iframe item", item);
           });*/
          /*document.querySelectorAll('iframe').forEach((item) => {
              console.log("Iframe item", item);
          });*/
          //this.dhxWindow.show();
      },
      createAlertRingElement: function() {
        this.AlertGuid = window.LivingScript_0070.guid.generateSync();
        this.alertPlayback = "alertPlayback"+ this.AlertGuid;
        this.alertSource = "alertSource"+ this.AlertGuid;
        console.log("Got Alert params create Announcement",this.alertSource);
        var alertpaneldiv = '<div style="display:none;"><audio id="'+this.alertPlayback+'" autoplay><source id="'+this.alertSource+'" type="audio/mp3" src=""></audio></div>';
        var t = document.getElementById("mediaElements");
        t.innerHTML = alertpaneldiv;
      },
      startAnnouncement: function(params) {
        this.dhxWindow[params.AlertID].hide();
        console.log("Got Alert params start Announcement",params.soundFile);
        document.getElementById(this.alertSource).src = params.soundFile;
        document.getElementById(this.alertPlayback).autoplay = true;
        document.getElementById(this.alertPlayback).load();
      },
      stopAnnouncement: function(params) {
         this.dhxWindow[params.AlertID].hide();
         document.getElementById(this.alertSource).src = "";
         document.getElementById(this.alertPlayback).pause();
         document.getElementById(this.alertPlayback).autoplay = false;
         document.getElementById(this.alertPlayback).load();
      }
  },
  beforeDestroy() {
    if (this.dhxWindow) {
      this.dhxWindow.destructor();
    }
  },
};

function btnAlerttest() {
  console.log("btn alert test");
}

function btnAlerttest2() {
  console.log("btn alert test");
}
</script>
